import formButton from '@/components/common/form-button/form-button.vue'
import { mapActions } from 'vuex'
import store from '@/store'
import router from '@/router'

export default {
  components: {
    formButton
  },
  data() {
    return {
      loginMessage: ''
    }
  },
  methods: {
    ...mapActions('auth', ['getThisUserInfo']),
    ...mapActions(['resetState']),
    fetchData() {
      this.getThisUserInfo()
        .then(() => {
          router.push({ name: 'dashboard' })
        })
        .catch((error) => {
          throw error.response
        })
    }
  },
  created() {
    this.fetchData()
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch('app/getXCsrfToken')
    next()
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/page-saml-loading/page-saml-loading.js